import { render, staticRenderFns } from "./MedicalStaffMapping.vue?vue&type=template&id=78f48b97"
import script from "./MedicalStaffMapping.vue?vue&type=script&lang=js"
export * from "./MedicalStaffMapping.vue?vue&type=script&lang=js"
import style0 from "./MedicalStaffMapping.vue?vue&type=style&index=0&id=78f48b97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports